var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":_vm.$store.getters.userIsGMAdmin ? '/admin' : '/mss-admin'}},[_c('cog-icon',{staticClass:"icon-cog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }